import { UntypedFormGroup, ValidatorFn } from '@angular/forms'
import { Matrix } from 'app/models/questions/Matrix'
import { ViewerTypeEnum } from 'app/enums/ViewerTypeEnum'
import {CheckboxMatrix} from "../models/questions/CheckboxMatrix";

export function requireMinRowSelection(matrix: Matrix): ValidatorFn {
  return function validate(formGroup: UntypedFormGroup) {

    if (matrix.viewerType === ViewerTypeEnum.RADIO_MATRIX || !matrix.limitAnswersAmount) {
      return null
    }

    const rowKeys = Object.keys(formGroup.controls)

    for (const idx in rowKeys) {
      let selectionCountForRow = 0
      const control = formGroup.controls[rowKeys[idx]]

      if (!control.enabled) {
        continue
      }
      if (matrix.useUniqueMentionLabel && (control.get(matrix.formControlName).value[(matrix as CheckboxMatrix).uniqueMentionKey])){
        continue
      }

      const statementValues = control.get(matrix.formControlName).value
      for (const sKey in statementValues) {
        if (statementValues[sKey]) {
          selectionCountForRow++
        }
      }
      if (selectionCountForRow < matrix.minAnswers.rows) {
        return {
          requireMinRowSelection: true
        }
      }
    }

    return null
  }
}
